import { render, staticRenderFns } from "./FormBuilder.vue?vue&type=template&id=2df3cf58&scoped=true&"
import script from "./FormBuilder.vue?vue&type=script&lang=js&"
export * from "./FormBuilder.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilder.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FormBuilder.vue?vue&type=style&index=1&id=2df3cf58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df3cf58",
  null
  
)

export default component.exports